export enum MasterTaskType {
    External = 1,
    Internal = 2,
    Other = 3
}